module.exports = __webpack_public_path__ + "3f16e137/img/search-filter-icon.c4751a52.svg";